import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const DigitalSignatureModule = () => (
  <QPhototModuleSubtopic
    title="Digital Signature Authentication, Authentication Protocols, Digital Signature Standards, RSA Digital Signature, Elgamal based Digital Signature"
    videos={[
      "https://www.youtube.com/embed/yUeI4nqvNs8",
      "https://www.youtube.com/embed/xPRdrzo46HI",
      "https://www.youtube.com/embed/EYOmHSxSOMA",
      "https://www.youtube.com/embed/jXw-CXYT01M",
      "https://www.youtube.com/embed/rLR8WcXy03Q",
      "https://www.youtube.com/embed/EUK4_d_ixoY"
    ]}
    takeaways={[]}
    questions={[
      {
        text:
          "Person A wants to send a message to Person B. Both agreed to use SHA-1 for obtaining the message digest. Let the generated message digest for the message be 4. Both agree on the public key components {p, q, h} as {23, 11, 7}. Person A selects his private key as 3. Let the pseudorandom integer k be 5. Demonstrate the step-by-step calculation for the following:\n• Generate the digital signature using DSS.\n• Signature verification."
      },
      {
        text:
          "Given parameters (p, q, h) = (31, 5, 3) and Alice’s private key x = 4; Alice’s random integer k is 3. Hash of message H(M) = 21. Generate a digital signature using the Digital Signature Standard (DSS) and verify the same."
      },
      {
        text:
          "Using the ElGamal digital signature scheme, User A chose p = 13, q = 2, private key X_A = 3, H(m) = 11, k = 5. He announces the global components publicly.\n(i) Find the public key Y_A.\n(ii) How does User A perform the signing process to compute (S1, S2)?\n(iii) How does User B perform the verification process?"
      },
      {
        text:
          "Alice wants to sign a message using the ElGamal signature scheme with small values for easy computation. She chooses a prime modulus q = 23, a generator α = 5, and her secret key X_a = 6. She needs to sign a message with hash value h(M) = 9 using a randomly chosen integer k = 7. Illustrate the steps involved in the signing process and the verification process."
      },
      {
        text:
          "Bob wants to generate a digital signature using DSA with the prime modulus p = 67, subgroup order q = 11, and h = 3.\n(i) Compute the value of g and check whether it is prime or not.\n(ii) Assume Bob selects the per-message secret integer as 7, the pseudorandom integer k as 5, and the hash of the message as 13. What would be the signer’s digital signature components?\n(iii) How does the receiver verify the signature components sent by Bob?"
      },
      {
        text:
          "Use the RSA digital signature scheme. Given the prime numbers p = 11 and q = 13, and the public key exponent e = 7, perform the following tasks:\n(a) How do you know the choice of e is valid?\n(b) Compute the private key exponent d.\n(c) Generate the digital signature for the given hash code w = 25.\n(d) Verify the signature to confirm the integrity and non-repudiation of the source."
      },
      {
        text:
          "Consider the ElGamal signature scheme with p = 467, α = 2, and X_a = 127. Perform detailed signing and verification procedures for the hash of the message h(M) = 100 and k = 213."
      },
      {
        text:
          "Illustrate the signing and verification process of the ElGamal digital signature scheme with a complete step-by-step example."
      },
      {
        text:
          "Given parameters (p, q, h) = (31, 5, 3) and Alice’s private key x = 4; Alice’s random integer k is 3. Hash of message H(M) = 21. Generate a digital signature using the Digital Signature Standard (DSS) and verify the same."
      },
      {
        text:
          "Person A wants to send a message to Person B. Both agreed to use SHA-1 for obtaining the message digest. Let the generated message digest for the message be 4. Both agree on the public key components {p, q, h} as {23, 11, 7}. Person A selects his private key as 3. Let the pseudorandom integer k be 5. Demonstrate the step-by-step calculation for the following:\n• Generate the digital signature using DSS.\n• Signature verification."
      }
    ]}
    exampleVideos={[]}
  />
);

export default DigitalSignatureModule;
